export const GET_LOG = "GET_LOG";
export const WRITE_LOG = "WRITE_LOG";
export const WRITE_IMPORTANTLOG = "WRITE_IMPORTANTLOG";
export const WRITE_SUPERVISORLOG = "WRITE_SUPERVISORLOG";
export const GET_IMPORTANTLOG = "GET_IMPORTANTLOG";
export const GET_SUPERVISORLOG = "GET_SUPERVISORLOG";
